/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ICreateInternalRegulationObligationRiskMutationVariables = Types.Exact<{
  input: Types.ICreateInternalRegulationObligationRiskInput;
}>;

export type ICreateInternalRegulationObligationRiskMutation = {
  __typename?: 'Mutation';
  createInternalRegulationObligationRisk: {
    __typename?: 'InternalRegulationObligationRisk';
    id: string;
    name?: string | null;
    approvalStatus?: Types.IInternalRegulationObligationApprovalStatus | null;
  };
};

export const CreateInternalRegulationObligationRiskDocument = gql`
  mutation CreateInternalRegulationObligationRisk($input: CreateInternalRegulationObligationRiskInput!) {
    createInternalRegulationObligationRisk(input: $input) {
      id
      name
      approvalStatus
    }
  }
`;
export type ICreateInternalRegulationObligationRiskMutationFn = Apollo.MutationFunction<
  ICreateInternalRegulationObligationRiskMutation,
  ICreateInternalRegulationObligationRiskMutationVariables
>;

/**
 * __useCreateInternalRegulationObligationRiskMutation__
 *
 * To run a mutation, you first call `useCreateInternalRegulationObligationRiskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInternalRegulationObligationRiskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInternalRegulationObligationRiskMutation, { data, loading, error }] = useCreateInternalRegulationObligationRiskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateInternalRegulationObligationRiskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateInternalRegulationObligationRiskMutation,
    ICreateInternalRegulationObligationRiskMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ICreateInternalRegulationObligationRiskMutation,
    ICreateInternalRegulationObligationRiskMutationVariables
  >(CreateInternalRegulationObligationRiskDocument, options);
}
export type CreateInternalRegulationObligationRiskMutationHookResult = ReturnType<
  typeof useCreateInternalRegulationObligationRiskMutation
>;
export type CreateInternalRegulationObligationRiskMutationResult =
  Apollo.MutationResult<ICreateInternalRegulationObligationRiskMutation>;
export type CreateInternalRegulationObligationRiskMutationOptions = Apollo.BaseMutationOptions<
  ICreateInternalRegulationObligationRiskMutation,
  ICreateInternalRegulationObligationRiskMutationVariables
>;
